import React, { useEffect, useRef, useState } from 'react'
import { useAxios } from '@/context/axiosContext'
import { LikdeList, RankList, YoutubeRankData } from './youtubeRankItem'
import { useDialog } from '@/context/dialogContext'
import { YoutubeListItem } from './_components/youtubeListItem'
import { useAppSelector } from '@/redux/hooks'
import MenuInfo from '../menu/menuInfo'
import { MenuHeader } from '../menu/menuHeader'
import { useLocation } from 'react-router-dom'
import GGOOLLFF from '@/assets/images/thumbnaillogo500px.png'
import { SEO } from '@/components/seo/seo'
const YoutubeRank: React.FC = () => {
  const axios = useAxios()
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  const [listItem, setListItem] = useState<YoutubeRankData[]>([])
  const [likedItem, setLikedItem] = useState<YoutubeRankData[]>([])
  const [isOpen, setIsOpen] = useState(true)
  const { showAlert } = useDialog()

  useEffect(() => {
    getRankList()
  }, [])

  useEffect(() => {
    getLikedList()
  }, [listItem])

  const getRankList = async () => {
    const response = await axios.get(`/youtube/getRankList`, {
      headers: { 'Cache-Control': 'no-cache' },
    })

    const { rankList } = response.data.data

    if (rankList && Array.isArray(rankList)) {
      setListItem(rankList)
    }
  }

  const getLikedList = async () => {
    const response = await axios.get(`/youtube/getLikedList`, {
      headers: { 'Cache-Control': 'no-cache' },
    })

    const { likedList } = response.data.data

    if (likedList && Array.isArray(likedList)) {
      setLikedItem(likedList)
    }
  }

  const setLikeStatus = async (
    formData: FormData,
    chnlId: string,
    currentLikeStatus: string,
  ) => {
    try {
      await axios.post(`/youtube/like`, formData)

      // API 성공 후 데이터 업데이트 (likeCount 조정)
      setListItem((prevItems) =>
        prevItems.map((item) =>
          item.chnlId === chnlId
            ? {
                ...item,
                likeCount:
                  currentLikeStatus === 'Y'
                    ? item.likeCount - 1
                    : item.likeCount + 1,
                userLikeYn: currentLikeStatus === 'Y' ? 'N' : 'Y',
              }
            : item,
        ),
      )
    } catch (err: any) {
      showAlert({
        type: 'error',
        title: '좋아요 요청이 되지 않았어요.',
      })
    }
  }

  return (
    <>
      <SEO
        title="꿀플루언서"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/youtube"
      />
      <div style={{ padding: '0 16px' }}>
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={false}
          menuInfoRef={menuInfoRef}
          loginRequired={true}
          iconActive={hasMenuInfo}
        />
      </div>
      {isAuthenticated && likedItem.length > 0 && (
        <YoutubeListItem
          title={LikdeList.title}
          data={likedItem}
          setLikeStatus={setLikeStatus}
          isLikedList={true}
        />
      )}

      {listItem.length > 0 ? (
        <YoutubeListItem
          title={RankList.title}
          noti={RankList.noti}
          data={listItem}
          setLikeStatus={setLikeStatus}
          isLikedList={false}
        />
      ) : (
        <div className="youtube-empty">
          <div>
            <img src={GGOOLLFF} alt="" width={'400px'} />
          </div>
          <div>아직 등록된 내용이 없어요.</div>
        </div>
      )}
      <div ref={menuInfoRef}>
        <MenuInfo menuPath={location.pathname} onDataCheck={setHasMenuInfo} />
      </div>
    </>
  )
}

export default YoutubeRank
